import { useEffect } from "react";
import Header from "@/components/Header";
import HeroLottie from "@/components/HeroLottie";
import FillCopy from "@/components/FillCopy";
import Rooms from "@/components/Rooms";
import Rewards from "@/components/Rewards";
import Cities from "@/components/Cities";
import HostSection from "@/components/HostSection";
import Expectations from "@/components/Expectations";
import Footer from "@/components/Footer";
import useLenisScroll from "@/hooks/useLenisScroll";

export default function Home() {
    useLenisScroll();
    useEffect(() => {
        document.title = "Vibecity - by Emergent";
    }, []);
    return (
        <main data-testid="home-page" className="relative">
            <Header />
            <HeroLottie />            {/* 1 · Hero */}
            <FillCopy />              {/* 2 · scroll-fill copy */}
            <Cities />                {/* 3 · City Chapters (Lead) */}
            <HostSection />           {/* 4 · Host an event (Open) */}
            <Rooms />                 {/* 5 · What Makes a Vibecity Lead */}
            <Expectations />          {/* 6 · Vibecity Playbook */}
            <Rewards />               {/* 7 · Real Budget, Real Reputation */}
            <Footer />                {/* 8 · map + CTA + logo footer */}
        </main>
    );
}
